export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8454.7690bded.jpg";